import {types} from './types';

const initialState = {
    list: {
        data: [],
        page: 0
    },
    view: {
        id: 0,
        start: NaN,
        end: NaN,
        label_name: '',
        description: '',
        fund: '0',
        count_winners: '1',
        winners: [0],
        price_ticket_deposit: 0,
        price_ticket: 0,
        gold_ticket: 0
    },
    stat: {
        data: [],
        page: 0
    },
    prize: {
        prizes: []
    },
    winners: {
        data: [],
        page: 0
    }
}

export function lotteryReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, list: action.payload};
        case types.SET_VIEW:
            return { ...state, view: action.payload};
        case types.SET_STAT:
            return { ...state, stat: action.payload};
        case types.SET_PRIZE:
            return { ...state, prize: action.payload};
        case types.SET_WINNERS:
            return { ...state, winners: action.payload};
        default:
            return state
    }
}